import { useSnackbar } from 'notistack';

import { useUpdateStudentPersonalInfoMutation } from '@/services/student';
import { definitions } from '@/types/schema';
import { isValidNumber } from '@/utils/common';

type StudentInfoUpdateProps = {
  studentId?: number;
  payload: definitions['EditProfileDto'];
};

export const useUpdateStudentInfo = () => {
  const [triggerUpdateStudentInfo] = useUpdateStudentPersonalInfoMutation();
  const { enqueueSnackbar } = useSnackbar();

  const handleStudentInfoUpdate = async ({
    studentId,
    payload,
  }: StudentInfoUpdateProps) => {
    if (!isValidNumber(studentId)) {
      enqueueSnackbar(
        `Failed to update student details. Please try again later`,
        {
          variant: `error`,
        },
      );
      return null;
    }

    const studentInfoUpdateResponse = await triggerUpdateStudentInfo({
      studentId: studentId as number,
      ...payload,
    }).unwrap();
    if (!studentInfoUpdateResponse?.success) {
      enqueueSnackbar(
        `Failed to update student details. Please try again later`,
        {
          variant: `error`,
        },
      );
      return null;
    }
    return studentInfoUpdateResponse?.data;
  };
  return { handleStudentInfoUpdate };
};
